// Локально захостенные шрифты (self) — @fontsource бандлится Vite в /assets,
// поэтому CSP `font-src 'self'` их разрешает и кириллица всегда полная.
// Inter: веса 400/500/600/700, поднаборы latin + cyrillic (family 'Inter' в theme.font.family).
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/cyrillic-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/cyrillic-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/cyrillic-700.css';
// JetBrains Mono: вес 400, latin + cyrillic (family 'JetBrains Mono' в theme.font.mono).
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/cyrillic-400.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
